import { createDynamicThunk } from ".";

export const getDesignationListThunk = createDynamicThunk({
  typePrefix: "designations/getDesignationListThunk",
  useHandleSearch: true,
});

export const addDesignationThunk = createDynamicThunk({
  typePrefix: "designations/addDesignationThunk",
  endpoint: "/designations",
  method: "POST",
  refreshList: true,
  listThunk: getDesignationListThunk,
});

export const editDesignationThunk = createDynamicThunk({
  typePrefix: "designations/editDesignationThunk",
  endpoint: "/designations",
  method: "PUT",
  refreshList: true,
  listThunk: getDesignationListThunk,
  transformResponse: (response) => response,
});

export const deleteDesignationThunk = createDynamicThunk({
  typePrefix: "/deleteDesignationThunk",
  endpoint: "/softDeleteMul",
  method: "POST",
  refreshList: true,
  listThunk: getDesignationListThunk,
});
